import {Injectable} from "@angular/core";
import {UnsubscribeBaseServiceModel} from "../client/UnsubscribeBaseService.model";
import {AppData} from "../AppData";
import { HttpClient } from "@angular/common/http";
import {CompoApp} from "../CompoApp";
import {Observable} from "rxjs/internal/Observable";
import {UrlBuilder} from "../../models/frontend_entities/UrlBuilder";
import Constants from "../../Constants";
import {take} from "rxjs/operators";
import {DocumentTypeDtoModel} from "../../models/designations-and-icon/document-type-dto.model";

@Injectable()
export class DocumentTypeRequestService extends UnsubscribeBaseServiceModel {

  //region FIELDS
  private data: AppData;

  //endregion

  //region CONSTRUCTOR
  constructor(private http: HttpClient,
              private app: CompoApp) {
    super();
    this.data = app.data;
  }
  //endregion

  //region REQUEST METHODS
  createDocumentType(model: DocumentTypeDtoModel): Observable<DocumentTypeDtoModel> {
    const url = new UrlBuilder(Constants.URLS.documentType.save)
      .param('accessMode', this.data.getAccessMode())
      .param('lang', this.data.getLang())
      .build();

    return this.http.post<DocumentTypeDtoModel>(url, model).pipe(take(1));
  }

  updateDocumentType(model: DocumentTypeDtoModel) : Observable<DocumentTypeDtoModel> {
    const url = new UrlBuilder(Constants.URLS.documentType.update)
      .param('lang', this.data.getLang())
      .param('accessMode', this.data.getAccessMode())
      .build();

    return this.http.put<DocumentTypeDtoModel>(url, model).pipe(take(1));
  }

  deleteDocumentType(id: string) : Observable<void> {
    const url = new UrlBuilder(Constants.URLS.documentType.delete)
      .param('id', id)
      .param('lang', this.data.getLang())
      .param('accessMode', this.data.getAccessMode())
      .build();

    return this.http.put<void>(url, null).pipe(take(1));
  }

  //endregion

}
